import { isString } from '@pogokid/util/lodash'
import { ContactSchema } from '../../.types/Contact.schema'

export function isContact(data: unknown): data is ContactSchema {
  return (
    !!data &&
    typeof data === 'object' &&
    'name' in data &&
    [isString(data.name)].every(Boolean)
  )
}
